import { render } from "./Acknowledgement.vue?vue&type=template&id=3f2ca752&scoped=true"
import script from "./Acknowledgement.vue?vue&type=script&lang=js"
export * from "./Acknowledgement.vue?vue&type=script&lang=js"

import "./Acknowledgement.vue?vue&type=style&index=0&id=3f2ca752&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2ca752"]])

export default __exports__